// extracted by mini-css-extract-plugin
export default {"container":"film_container__3wku3","inner":"film_inner__3yOOl","isContainer":"film_isContainer__1x9EF"};